import {
  updateCartInfo,
  fetchExternalGiftTableProducts,
} from 'store/actions/externalGiftTable';
import { fetchGiftTableInfo } from 'store/actions/giftTable';
import {
  initialValuesStepOne,
  schemaStepOne,
  titleStepOne,
} from './steps/One/config';
import {
  initialValuesStepTwo,
  schemaStepTwo,
  titleStepTwo,
} from './steps/Two/config';
import {
  initialValuesStepThree,
  schemaStepThree,
  titleStepThree,
} from './steps/Three/config';
import { StepOne, StepTwo, StepThree } from './steps';

export const STEPS = {
  ONE: 'ONE',
  TWO: 'TWO',
  THREE: 'THREE',
};

export const stepsInitialValues = {
  [STEPS.ONE]: initialValuesStepOne,
  [STEPS.TWO]: initialValuesStepTwo,
  [STEPS.THREE]: initialValuesStepThree,
};

export const stepsSchemas = {
  [STEPS.ONE]: schemaStepOne,
  [STEPS.TWO]: schemaStepTwo,
  [STEPS.THREE]: schemaStepThree,
};

export const stepsTitles = {
  [STEPS.ONE]: titleStepOne,
  [STEPS.TWO]: titleStepTwo,
  [STEPS.THREE]: titleStepThree,
};

export const PAYMENT_STEPS = {
  [STEPS.ONE]: StepOne,
  [STEPS.TWO]: StepTwo,
  [STEPS.THREE]: StepThree,
};

export const getIndexOfStep = (currentStep) =>
  Object.entries(STEPS)
    .map(([, value], index) => [index, value])
    .find(([, value]) => value === currentStep);

export const actions = {
  updateCartInfo,
  fetchExternalGiftTableProducts,
  fetchGiftTableInfo,
};
